module.exports = __webpack_public_path__ + "img/67.a3abde4d.jpg";